// extracted by mini-css-extract-plugin
export var avatarContainer = "_ck-0";
export var avatarTypingWave = "_ck-i";
export var gray = "_ck-f";
export var green = "_ck-c";
export var icon = "_ck-9";
export var image = "_ck-1";
export var lg = "_ck-6";
export var md = "_ck-5";
export var presenceDot = "_ck-b";
export var red = "_ck-d";
export var sm = "_ck-4";
export var status = "_ck-a";
export var typingDot = "_ck-h";
export var typingPill = "_ck-g";
export var xl = "_ck-7";
export var xs = "_ck-3";
export var xxl = "_ck-8";
export var xxs = "_ck-2";
export var yellow = "_ck-e";